define('model/disclosure.detail.model',['require','exports','module','fukit/fukit','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel = require('fukit/fukit').BaseModel,
      DataKit   = require('datakit/datakit');

  var DisclosureDetailModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureDetailModel': '@constructor',
    },

    urlRoot: '/api/v2/coi/disclosure/disclosee/listdisclosures',

    modifyURL: '/api/v2/coi/disclosure/modify',

    modifyDisclosure: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.modifyURL, this, this._urlParams),
            type: 'PUT',
            contentType: 'application/json',
          },
          options
        )
      );
    },
  });

  module.exports = DisclosureDetailModel;
});

